(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', '@material-ui/core/DialogTitle', 'react-emotion', '../../styles', '../../elements'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('@material-ui/core/DialogTitle'), require('react-emotion'), require('../../styles'), require('../../elements'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.DialogTitle, global.reactEmotion, global.styles, global.elements);
    global.ModalHeader = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _DialogTitle, _reactEmotion, _styles, _elements) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  var _DialogTitle2 = _interopRequireDefault(_DialogTitle);

  var _elements2 = _interopRequireDefault(_elements);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n          background-color: ', ';\n        '], ['\n          background-color: ', ';\n        ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    background-color: ', ';\n  '], ['\n    background-color: ', ';\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    justify-content: space-between;\n    color: ', ';\n    font-size: 1.5625rem;\n    font-family: \'Proxima Nova\', Arial, Helvetica, sans-serif;\n  '], ['\n    display: flex;\n    justify-content: space-between;\n    color: ', ';\n    font-size: 1.5625rem;\n    font-family: \'Proxima Nova\', Arial, Helvetica, sans-serif;\n  ']);

  var ModalHeader = function ModalHeader(_ref) {
    var Icon = _ref.icon,
        color = _ref.color,
        children = _ref.children;
    return React.createElement(
      _DialogTitle2.default,
      {
        className: (0, _reactEmotion.cx)(classes.header, color && (0, _reactEmotion.css)(_templateObject, color))
      },
      React.createElement(
        'div',
        { className: classes.headerText },
        children,
        Icon && React.createElement(Icon, null)
      )
    );
  };

  ModalHeader.defaultProps = {
    icon: null
  };

  var classes = {
    header: (0, _reactEmotion.css)(_templateObject2, _styles.colors.gold),
    headerText: (0, _reactEmotion.css)(_templateObject3, _styles.colors.prussian)
  };

  exports.default = ModalHeader;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Modal/ModalHeader.js
// module id = 1228
// module chunks = 0